// ParkingPage.jsx
import React from "react";
import { Navigation } from "../components/navigation";
import { ParkingProducts } from "../components/parking-products";
import { CarwashContact } from "../components/carwash-contact";
import { CarwashEquipment } from "../components/carwash-equipment";
import { CarwashFeatures } from "../components/carwash-features";
import { Footer } from "../components/footer";

export const ParkingPage = () => {
  return (
    <div>
      <Navigation />
      <ParkingProducts />
      <CarwashEquipment />
      <CarwashContact product="Parking Pay Station" industry="parking" />
      <CarwashFeatures />
      <Footer />
    </div>
  );
};
